import api from "api";
import BlockHeader from "component/BlockHeader/BlockHeader";
import PaginationWrapper from "component/Pagination";
import {InitiativeList} from "component/InitiativeList";
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { createBrowserHistory, parsePath } from "history";
import { useLocation, useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import stateMap from "store/stateMap";
import update from 'immutability-helper';
import "./../../../Browse/style.scss";
import Sidebar from "component/Sidebar";
import _ from "lodash";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import Breadcrumb from "component/Breadcrumb";
import { PageCredential } from "component/PageCredential";

export default connect(stateMap)((props) => {

    const researchByTarget = [
        ['rnd'                   , 'Prototype R&D']
        ,['prototipe'            , 'Prototype Industry']
        ,['community-research'   , 'Research used by the community']
        ,['industry-product'     , 'Innovative products used by industry']
    ];

    const [researchField, setResearchField] = useState(false);
    useEffect(() => {
        api('/ResearchField', 'get', {
            posts_per_page : -1
        })
            .then(response => {
                setResearchField(response.field);
            })
    }, []);

    let location                                = useLocation();
    let history                                 = createBrowserHistory();
    
    const [initiatives, setInitiatives]         = useState(false);
    const [countInitiative, setCountInitiative] = useState(false);
    const [dataLoading, setDataLoading]         = useState(false) ;
    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    const [parameter, setParameter]             = useState({
        paged           : parseInt(queryString.get('page') || 1)  
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 9
        ,research_type : queryString.get('research_type') || ''
        ,target_product : queryString.get('target_product') || ''
        ,research_field : queryString.get('research_field') || ''
        ,opportunity : queryString.get('opportunity') || ''
    });


    const changeParams = (e) => {
        e.preventDefault();

        if(dataLoading)
        {
            return;
        }

        let [toUpdateFilter, updatedValue] = e.currentTarget.name.split(':');

        setParameter(
            update(parameter, { $apply : function(params){

                if(params[toUpdateFilter] == updatedValue)
                {
                    params[toUpdateFilter] = '';
                }
                else
                {
                    params[toUpdateFilter] = updatedValue;
                }
    
                params.paged = 1;
    
                return _.assign({}, params);
    
            }})
        );
    }

    const loadInitiative = () => {

        if(dataLoading)
        {
            return;
        }

        var research_metadata = 0;

        if(parameter.research_type || parameter.target_product || parameter.research_field)
        {
            research_metadata = 1;
        }

        var DataToLoad = [
            api('/Initiative', 'get', {...parameter, type : 'research', platform_synced : parameter.opportunity, research_metadata : research_metadata })
        ];

        if(parameter.paged === 1)
        {
            DataToLoad.push(
                api('/Initiative', 'get', {...parameter, type : 'research', get_total : 1, platform_synced : parameter.opportunity, research_metadata : research_metadata} )
            );
        }

        setDataLoading(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setDataLoading(false);

                setInitiatives(response[0].initiative);

                history.replace(
                    { search: `?${createSearchParams(parameter)}`}
                );

                if(parameter.paged === 1)
                {
                    setCountInitiative( parseInt(response[1].initiative) );
                }

            })
            .catch((error) => {
                setDataLoading(false);
                
            })
    }
    
    useEffect(loadInitiative, [props.auth.user, parameter]);

    return(
        <>
            <Header/>
            <PageCredential title={"Archive of Research Initiatives "}/>
            <div id="initiative-archives" className="container relative">
                <Sidebar>
                    <div className="initiatives-filters filters-boxes">
                        <div className="filters-boxes mb-md">
                            <div className="filter-box">
                                <div className="wrapper">
                                    <span className="filter-title">
                                        Research Type
                                    </span>
                                    <div className="filter-body">
                                        <ul className="filter-items">
                                            <li 
                                                className={`leading-text filter-item ${'basic' == parameter.research_type && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`research_type:basic`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Basic' }}/>
                                            </li>
                                            <li 
                                                className={`leading-text filter-item ${'applied' == parameter.research_type && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`research_type:applied`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Applied Research' }}/>
                                            </li>
                                            <li 
                                                className={`leading-text filter-item ${'development' == parameter.research_type && 'active'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`research_type:development`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Advanced Research' }}/>
                                            </li>
                                            <li 
                                                className={`leading-text filter-item ${'bridge' == parameter.opportunity && 'active mt-sm'}`}>
                                                    <a 
                                                        href="#" 
                                                        name={`opportunity:bridge`} 
                                                        onClick={changeParams} 
                                                        dangerouslySetInnerHTML={{__html : 'Opportunity x BINUS BRIDGE' }}/>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filters-boxes mb-md">
                            <div className="filter-box">
                                <div className="wrapper">
                                    <span className="filter-title">
                                        Target Output
                                    </span>
                                    <div className="filter-body">
                                        <ul className="filter-items">
                                            {
                                                researchByTarget.map(target => (
                                                    <li 
                                                    key={target[0]}
                                                        className={`leading-text filter-item ${target[0] == parameter.target_product && 'active'}`}>
                                                            <a 
                                                                href="#" 
                                                                name={`target_product:${target[0]}`} 
                                                                onClick={changeParams} 
                                                                dangerouslySetInnerHTML={{__html : target[1] }}/>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filters-boxes">
                            <div className="filter-box">
                                <div className="wrapper">
                                    <span className="filter-title">
                                        Research Fields
                                    </span>
                                    <div className="filter-body">
                                        <ul className="filter-items">
                                            {

                                                researchField !== false && researchField.map(field => (
                                                    <li 
                                                        key={field.ResearchFieldID}
                                                        className={`leading-text filter-item ${field.ResearchFieldID == parameter.research_field && 'active'}`}>
                                                            <a 
                                                                href="#" 
                                                                name={`research_field:${field.ResearchFieldID}`} 
                                                                onClick={changeParams} 
                                                                dangerouslySetInnerHTML={{__html : field.FieldName }}/>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Sidebar>
                <div className="initiative-list-container">
                    <Breadcrumb
                        items={[
                            ['/', 'Crowdbees']
                            ,['/research', 'Research Activity']
                            ,['Browse']
                        ]}
                    />
                    <div className="initiatives-list">
                        {
                            initiatives === false ? <span className="skeleton"></span>:
                            (
                                <Fragment>
                                    {
                                        dataLoading ? <div><span className="skeleton"></span></div> :
                                        <>
                                            { 
                                                <BlockHeader title="Research" desc={"About "+ countInitiative +" initiatives"}/>
                                            }
                                            <InitiativeList initiatives={initiatives}/>
                                            <PaginationWrapper
                                                className="mt-4"
                                                activePage={parameter.paged}
                                                itemsCountPerPage={parameter.posts_per_page}
                                                totalItemsCount={countInitiative}
                                                pageRangeDisplayed={5}
                                                onChange={(pagenumber) => {
                                                    setParameter(update(parameter, { paged : {$set : pagenumber } }))
                                                }}
                                            />
                                        </>
                                    }
                                </Fragment>
                            )
                        }
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
});